import { useMutation, useQuery } from '@tanstack/react-query';

import AppApi from '@/apis/app-api';
import FortuneApi, { CreateFortuneBodyDto } from '@/apis/fortune';
import { baseUrl } from '@/consts/route';

import { useAuth } from './useAuth';

export const useFortune = ({ shopName, openedAt }) => {
  const { accessToken, userId } = useAuth();
  const getFortune = async () => {
    const api = new AppApi(baseUrl);

    api.setup(accessToken);
    const fortuneApi = new FortuneApi(api);

    const res = await fortuneApi.getFortune({
      shopName,
      openedAt,
    });

    return res;
  };

  return useQuery({
    queryKey: ['fortune', userId, shopName, openedAt],
    queryFn: getFortune,
  });
};

export const useFortuneCreate = () => {
  const { accessToken, userId } = useAuth();
  const getFortune = async ({ shopName, openedAt, userId, category }: CreateFortuneBodyDto) => {
    const api = new AppApi(baseUrl);

    api.setup(accessToken);
    const fortuneApi = new FortuneApi(api);

    const res = await fortuneApi.create({
      shopName,
      openedAt,
      userId,
      category,
    });

    return res;
  };

  return useMutation({
    mutationFn: getFortune,
    mutationKey: ['fortune', userId],
  });
};

export const useFortuneUpdate = () => {
  const { accessToken, userId } = useAuth();
  const updateFortune = async (fortuneId: string) => {
    const api = new AppApi(baseUrl);

    api.setup(accessToken);
    const fortuneApi = new FortuneApi(api);

    const res = await fortuneApi.update({
      userId,
      fortuneId,
    });

    return res;
  };

  return useMutation({
    mutationFn: updateFortune,
    mutationKey: ['fortune', userId],
  });
};
